import { dateFormatNoTimeZone } from 'common/helpers/dateHelper';
import { phoneFormat } from 'common/helpers/phoneHelper';

const NoResults = (props) => {
  const { settings, reservationDate } = props;
  const primaryPhone = phoneFormat(
    settings.data.primaryPhone,
    settings.data.defaultCountryCode
  );

  return (
    <div className="c7-experiences c7-experiences--no-results">
      <p>
        <span className="c7-experiences__message">
          Unfortunately there are no experiences available on{' '}
          {dateFormatNoTimeZone(reservationDate)} matching your criteria.
        </span>
        Call for alternative options{' '}
        <a href={`tel:${primaryPhone}`}>{primaryPhone}</a>
        {/*

        The next available date is December 2nd, or call for alternative options{' '}
        <a href="tel:877.283.5934">877.283.5934</a>
        */}
      </p>
    </div>
  );
};

export default NoResults;
